import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection, FacilityCard } from '@components'
import './BukopinPriority.scss'
import { CardBukopinPrioritasAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import HeaderSection from '../../../common/components/Header/HeaderSection'
import MyLeafBox from '../../../common/components/MyLeafBox/MyLeafBox'
import { TitleComponent } from '../../../common/components/TitleComponent'
import CardItem from '../../../common/components/Cards/CardItem'
import CardTransaksiChannel from '../../../common/components/Cards/CardTransaksiChannel'
import CardSimpanan from '../../../common/components/Cards/CardSimpanan'

const BukopinPriorityContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Container = styled.div`
  padding-top: 50px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const H2 = styled.h2`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: rgb(94, 81, 77);
  margin-bottom: 12px;
`

const DarkSection = styled.section`
  background: #5e514d;
  padding: 30px;
  border-radius: 0px 32px;
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const P = styled.p`
  font-weight: 400;
  line-height: 150%;
  color: rgb(94, 81, 77);
`

const BukopinPriority = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(true)

  useEffect(() => {
    setisLoading(true)
    loadShortDescData()
    loadData()
  }, [])

  const loadData = async function () {
    const reportData = await CardBukopinPrioritasAPI('')
    setdata(reportData.data.data)
    setisLoading(false)
  }

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: 'bkpn_prioritas' })
    setShortDesc(data.data ? data.data[0] : '')
  }
  return (
    <BukopinPriorityContainer>
      <TitleComponent title={data?.titleBukopinPrioritas} />
      <Container>
        <Desktop>
          <HeaderSection
            title={data.titleBukopinPrioritas}
            group={t('bukopin_prioritas')}
            description={data.descriptionBukopinPrioritas}
            banner={data.banner}
            showButton={false}
          />
        </Desktop>
        <Mobile>
          <HeaderSection
            title={data.titleBukopinPrioritas}
            group={t('bukopin_prioritas')}
            description={data.descriptionBukopinPrioritas}
            banner={data.bannerMobile}
            showButton={false}
          />
        </Mobile>
      </Container>

      <div className="p-0 m-0 container-fluid">
        <div className="pt-4 mt-2 pb-0">
          <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 row">
            <MyLeafBox
              size={6}
              title={data.titleBukopinPrioritasCenter}
              description={data.descriptionPrioritasCenter}
            />
            <div className="col-lg-6">
              <H2>{data.titlePersyaratanMenjadiMember}</H2>
              <p
                dangerouslySetInnerHTML={{
                  __html: data.descriptionPersyaratanMenjadiMember,
                }}
              ></p>
            </div>
          </div>

          <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 mt-4">
            <DarkSection>
              <div className="row">
                <div className="col-lg-4">
                  <H2 className="text-white">{data.titleLayananPrioritas}</H2>
                  <p className="text-white">
                    {data.descriptionLayananPrioritas}
                  </p>
                </div>
                <div className="col-lg-8">
                  <div id="style-overflow" style={{ paddingBottom: '25px' }}>
                    <div
                      className="d-flex"
                      // style={{
                      //   overflowX: "scroll",
                      //   flexWrap: "nowrap",
                      //   width: "100%",
                      // }}
                    >
                      <div className="row d-flex flex-nowrap">
                        {isLoading
                          ? []
                          : data.dataBlockLayananPrioritas.map((item) => {
                              return (
                                <div className="col-4">
                                  <div
                                    className="leaf"
                                    style={{
                                      left: '0px',
                                      borderRadius: '0px 24px',
                                      padding: '20px 20px 20px 20px',
                                      height: '220px',
                                      top: '0px',
                                      backgroundColor: 'white',
                                      marginRight: '16px',
                                    }}
                                  >
                                    <div className="ornament-right">
                                      <svg
                                        width="111"
                                        height="75"
                                        viewBox="0 0 111 75"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0_4266_6380)">
                                          <rect
                                            width="101.167"
                                            height="101.167"
                                            rx="12"
                                            transform="matrix(0.692765 -0.721163 0.692765 0.721163 56.0842 21.9816)"
                                            fill="#F2A900"
                                            fillOpacity="0.05"
                                          ></rect>
                                          <rect
                                            width="101.167"
                                            height="101.167"
                                            rx="12"
                                            transform="matrix(0.692765 -0.721163 0.692765 0.721163 0 2.05969)"
                                            fill="#F2A900"
                                            fillOpacity="0.05"
                                          ></rect>
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_4266_6380">
                                            <path
                                              d="M0 0H87C100.255 0 111 10.7452 111 24V75H0V0Z"
                                              fill="white"
                                            ></path>
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <p
                                      style={{
                                        fontStyle: 'normal',
                                        fontWeight: 'bold',
                                        fontSize: '20px',
                                        lineHeight: '150%',
                                        color: '#5E514D',
                                      }}
                                    >
                                      {item.subTitleLayananPrioritas}
                                    </p>
                                    <p
                                      style={{
                                        fontStyle: 'normal',
                                        fontWeight: 'normal',
                                        fontSize: '12px',
                                        lineHeight: '150%',
                                        color: '#5E514D',
                                      }}
                                    >
                                      {item.subDescriptionLayananPrioritas}
                                    </p>
                                  </div>
                                </div>
                              )
                            })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DarkSection>
          </div>

          <div className="mb-4 mt-5 mb-lg-0 mx-0 px-lg-5 mx-lg-5 row">
            <FacilityCard
              title={data.titleFasilitasBukopinPrioritas}
              items={isLoading ? [] : data.dataBlockFasilitasBukopinPrioritas}
            />
          </div>

          <div className="mb-4 mt-5 mb-lg-0 mx-0 px-lg-5 mx-lg-5 row">
            <div className="container">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-4 col-12">
                  <CardItem url={data.imageKartuBukopinPrioritas} />
                </div>
                <div className="col-lg-8 col-12 mt-5">
                  <p
                    style={{
                      fontWeight: 'bold',
                      fontSize: '24px',
                      lineHeight: '36px',
                      color: 'rgb(133, 113, 77)',
                    }}
                  >
                    {data.titleKartuBukopinPrioritas}
                  </p>
                  <p
                    className="mb-3 mb-lg-4"
                    style={{
                      fontStyle: 'normal',
                      fontWeight: 'normal',
                      fontSize: '14px',
                      lineHeight: '20px',
                      color: 'rgb(94, 81, 77)',
                    }}
                  >
                    {data.subTitleKartuBukopinPrioritas}
                  </p>
                  <div className="row">
                    {isLoading
                      ? []
                      : data.dataBlockKartuBukopinPrioritas.map((item) => {
                          return (
                            <div className="col-12 col-lg-6">
                              <MyLeafBox
                                size={12}
                                title={item.titleBlockKartuBukopinPrioritas}
                                description={
                                  item.descriptionBlockKartuBukopinPrioritas
                                }
                              />
                            </div>
                          )
                        })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterSection currentPage={t('bukopin_prioritas')} />
    </BukopinPriorityContainer>
  )
}

export default BukopinPriority
